/**
 * Listens for LLM API error events from Electron and shows error toasts.
 * Renders nothing — pure side-effect component.
 */

import { useEffect } from 'react';
import { useToast } from '../../contexts/ToastContext';

export function LlmErrorToastListener() {
  const { addToast } = useToast();

  useEffect(() => {
    if (!window.isElectron || !window.electronLlm?.onApiError) return;

    const unsubscribe = window.electronLlm.onApiError((event) => {
      addToast(event.userMessage, 'error', { duration: 8000 });
    });

    return unsubscribe;
  }, [addToast]);

  return null;
}
